// 应收单据
<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <listComponent v-if="tabCur == item.key" :columnsSource="item.columnsSource" :formSource="item.formSource"
          :formBtns="item.formBtns" :resultCode="item.resultCode" formType="payable" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import listComponent from "@/pages/bill-manage/receivable/list";
export default {
  components: {
    listComponent
  },
  data() {
    return {
      tabData: [
        {
          name: "查验已通过",
          resultCode: 1,
          key: "checkSuccess",
          formBtns: ["revokeBtn", "importBtn", "addContract", "delContract", "addvoucher"],
          columnsSource: [
            "查验编号",
            "买方名称",
            "发票类型",
            "发票代码",
            "发票号码",
            "开票日期",
            "不含税金额(元)",
            "含税金额(元)",
            "查验方式",
            "合同编号",
            "相关附件",
            "使用状态"
          ],
          formSource: [
            "buryOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceCode",
            "invoiceNumber",
            "billTime",
            "checkType",
            "contractNo",
            "useStatus"
          ]
        },
        {
          name: "未查验",
          resultCode: 3,
          formBtns: ["deletBtn", "applyUserBtn"],
          key: "checkNo",
          columnsSource: [
            "导入时间",
            "买方名称",
            "发票类型",
            "发票代码",
            "发票号码",
            "开票日期",
            "不含税金额(元)",
            "含税金额(元)",
            "操作"
          ],
          formSource: [
            "buryOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime",
          ]
        },
        {
          name: "查验中",
          resultCode: 0,
          key: "checkIng",
          columnsSource: [
            "查验编号",
            "买方名称",
            "发票类型",
            "发票代码",
            "发票号码",
            "开票日期",
            "不含税金额(元)",
            "含税金额(元)",
            "查验方式"
          ],
          formSource: [
            "buryOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime",
            "checkType"
          ]
        },
        {
          name: "查验不通过",
          resultCode: 2,
          key: "checkRefuse",
          formBtns: ["deletBtn", "applyBtn", "applyUserBtn"],
          columnsSource: [
            "查验编号",
            "买方名称",
            "发票类型",
            "发票号码",
            "开票日期",
            "不含税金额(元)",
            "含税金额(元)",
            "查验方式",
            "操作"
          ],
          formSource: [
            "buryOrgCode",
            "cyCode",
            "invoiceType",
            "invoiceNumber",
            "billTime",
            "checkType"
          ]
        }
      ],
      tabCur: "checkSuccess",
      InvoiceTypeOption: []
    };
  },
  created() {
    this.tabCur = this.$route.query.tabCur || "checkSuccess";
  }
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/receivable/index.vue